<template>
  <div>
    <div class="col-xs-12">
      <div v-if="!hasChart">
        <spinner /> Desenhando os gráficos da estação. Por favor, aguarde...
      </div>
      {{ noChartWarning }}
      <div id="monitoringStation"></div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts"; //apex
import moment from "moment";

import { monitChart } from "@/api";
import { organizeLog } from "@/pages/components/monit/charts";

export default {
  name: "chart-station",
  props: {
    items: Array,
    nameStation: String,
    altitude: Number,
    anemometerHeight: Number,
    latitude: Number,
    longitude: Number,
    utc: [String, Number],
  },
  created() {
    this.controller = new AbortController();
    this.tryChart();
  },
  data() {
    return {
      controller: null,
      noChartWarning: "",
      hasChart: false,
      eqp: "SENSOR",
      charts: [],
      apexCharts: null,
      start: "",
      end: "",
    };
  },
  mounted() {
    this.apexCharts = document.getElementById("monitoringStation"); //apex
  },
  beforeDestroy() {
    if (this.charts.length) this.charts.forEach((e) => e.destroy()); //apex
    this.cancelActualRequestIfExists();
  },
  methods: {
    cancelActualRequestIfExists() {
      this.controller.abort();
    },
    tryChart() {
      this.hasChart = false;
      if (this.items && this.items.length) this.callChart();
      else {
        this.hasChart = true;
        this.noChartWarning =
          "Os equipamentos para o gráfico não foram identificados.";
      }
    },
    callChart() {
      this.emrSensor = this.items.filter((e) => e.INTERFACE == "EMR");
      let NAMES = [];
      let UNITS = [];
      let TYPES = [];
      this.emrSensor.map((e) => {
        NAMES.push(e.NAME);
        UNITS = [...UNITS, ...e.UNIT];
        TYPES = [...TYPES, ...e.TYPE];
      });
      let START = moment()
        .subtract(1, "week")
        .hours(0)
        .minutes(0)
        .format("YYYY-MM-DD HH:mm");
      let END = moment().format("YYYY-MM-DD HH:mm");
      this.start = START;
      this.end = END;
      // let data = ;
      Promise.resolve({
        EQP: this.eqp,
        NAME: NAMES.filter((e, i, arr) => arr.indexOf(e) == i),
        COLUMN: "UNIT",
        CONDITION: {
          TYPES: TYPES.filter((e, i, arr) => arr.indexOf(e) == i),
          UNITS: UNITS.filter((e, i, arr) => arr.indexOf(e) == i),
        },
        START,
        END,
      })
        .then((data) => monitChart.create(data, this.controller))
        .then((ret) => {
          if (ret.status) {
            return organizeLog(ret, "STATION", NAMES);
          } else {
            alert(ret.log, "w");
            throw ret.log;
          }
        })
        .then((e) => {
          this.hasChart = true;
          if (e.status) this.drawApexSyncCharts(e.value);
          else alert(e.log, "w");
        })
        .catch((err) => {
          this.hasChart = false;
          console.log(err);
        });
      // .then((_) => {

      //   this.hasChart = true;
      // });
    },
    //????
    calcLogsValue(logs) {
      let lastValue = Number(logs[logs.length - 1][1]);
      let newData = [];
      for (let [time, value] of logs) {
        let diff = Number(value) - lastValue;
        newData.push([time, diff.toFixed(2)]);
      }
      return newData;
    },
    drawApexSyncCharts(info) {
      //apex sync
      let color = [
        "rgba(255, 0, 0, 0.5)", //'red'
        "rgba(0, 0, 255, 0.5)", //'blue'
        "rgba(0, 255, 0, 0.5)", //'green'
        "rgba(0, 0, 0, 0.5)", //'black'
        "rgba(255, 0, 255, 0.5)", //'pink'
        "rgba(108, 117, 125, 0.5)", //'gray'
        "rgba(0, 255, 255, 0.5)", //'cyan'
        "rgba(255, 160, 0, 0.5)", //'orange'
        "rgba(160, 0, 255, 0.5)", //'purple'
        "rgba(0, 255, 160, 0.5)", //'teal'
      ];
      this.noChartWarning = "";
      let name = info.name;
      let count = 0;
      const formatMeasure = (measure) => {
        if (measure === "ALTURA PLUVIOMÉTRICA DIÁRIA") {
          return "PLUVIOMETRIA DIÁRIA";
        } else if (measure === "ALTURA PLUVIOMÉTRICA") {
          return "PLUVIOMETRIA";
        }
        return measure;
      };
      this.calcET0(info).then((infoWithET0) => {
        if (infoWithET0["ALTURA PLUVIOMÉTRICA"].data) {
          infoWithET0["ALTURA PLUVIOMÉTRICA"].data = this.calcLogsValue(
            infoWithET0["ALTURA PLUVIOMÉTRICA"].data
          );
        }
        if (
          infoWithET0["ALTURA PLUVIOMÉTRICA DIÁRIA"]["data"].filter(
            (e) => !!Number(e[1])
          ).length
        )
          infoWithET0.typesPerSns.splice(
            infoWithET0.typesPerSns.indexOf("ALTURA PLUVIOMÉTRICA") + 1,
            0,
            "ALTURA PLUVIOMÉTRICA DIÁRIA"
          );
        let columns = infoWithET0.typesPerSns;
        let len = columns.length;
        for (let i = 0; i < len; i++) {
          let col = columns[i];
          let { data, type, measure, unit /*,  max, min */ } = infoWithET0[col];
          let opts = {
            chart: {
              id: `chart-${i}`,
              group: `monitoringEMR`,
              type: ["ET0", "ALTURA PLUVIOMÉTRICA DIÁRIA", "P.M.F."].includes(
                col
              )
                ? "bar"
                : "line",
              height: 260,
              width: "100%",
              animations: {
                enabled: false,
              },
              markers: {
                size: 0,
              },
              toolbar: {
                show: true,
                offsetX: 14,
                offsetY: -5,
                tools: {
                  download: true,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                  customIcons: [],
                },
                export: {
                  csv: {
                    headerCategory: `Horário`,
                    filename: "Dados do gráfico",
                    dateFormatter(timestamp) {
                      return moment(timestamp).format("DD/MM/YYYY HH:mm");
                    },
                  },
                },
              },
            },
            series: [
              {
                name: `${formatMeasure(measure)} (${unit})`,
                data,
              },
            ],
            xaxis: {
              type: "datetime",
              labels: {
                datetimeUTC: false,
                format: "dd/MM/yyyy HH:mm",
                datetimeFormatter: {
                  year: "yyyy",
                  month: "MMM 'yy",
                  day: "dd MMM",
                  hour: "HH:mm",
                },
                // hideOverlappingLabels: true,
              },
            },
            responsive: [
              {
                breakpoint: 1000,
                options: {
                  plotOptions: {
                    bar: {
                      horizontal: false,
                    },
                  },
                  legend: {
                    position: "bottom",
                  },
                  stroke: {
                    curve: "smooth",
                    width: 2,
                  },
                  title: {
                    style: {
                      fontSize: "10px",
                    },
                  },
                  dataLabels: {
                    style: {
                      fontSize: "0.5rem",
                      fontFamily: "Helvetica, Arial, sans-serif",
                      fontWeight: "bold",
                      colors: ["#fff"],
                    },
                  },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: "98%",
                    },
                  },
                  xaxis: {
                    type: "datetime",
                    labels: {
                      format: "dd/MM/yyyy",
                      datetimeFormatter: {
                        year: "yyyy",
                        month: "MMM 'yy",
                        day: "dd MMM",
                      },
                      hideOverlappingLabels: true,
                    },
                  },
                },
              },
            ],
            legend: {
              position: "top",
              verticalAlign: "top",
              containerMargin: {
                left: 35,
                right: 60,
              },
            },

            title: {
              text: `${formatMeasure(measure)} (${unit})`,
              align: "left",
              offsetX: 0,
              offsetY: 15,
              margin: 10,
              style: {
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: undefined,
                color: "#263238",
                margin: 10,
                overflow: "hidden",
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "97%",
                dataLabels: {
                  position: "center",
                  maxItems: 100,
                  hideOverflowingLabels: true,
                  orientation: "horizontal",
                  fontSize: "5px",
                },
              },
            },

            colors: [color[count]],
            yaxis: {
              min: function (min) {
                return min < 0 ? min : 0;
              },
              max: function (max) {
                //Exibir máximo de 24 para eixo Y
                // caso for molhamento foliar
                if (col === "P.M.F.") {
                  return 24;
                } else if (max == 0) return 5;
                return max;
              },
              labels: {
                minWidth: 20,
                offsetY: -10,
                style: {
                  fontSize: "11px",
                },
              },
            },
            tooltip: {
              x: {
                show: false,
                format: "dd/MM/yyyy HH:mm",
              },
            },
          };

          let div = document.createElement("DIV");
          div.id = `chart-${i}`;
          if (col === "P.M.F.") {
            opts.yaxis.labels.formatter = (val) => {
              return val.toFixed(0);
              // return parseFloat(`${integer}.${Math.ceil(decimal*60)}`)
            };
            opts.yaxis.forceNiceScale = true;
          }
          this.apexCharts.appendChild(div);
          let chart = new ApexCharts(div, opts);
          this.charts.push(chart);
          chart.render();

          //to change next color
          if (count < 9) count++;
          else count = 0;
        }
      });
    },
    calcET0(info) {
      return new Promise((resolve) => {
        let hours = [
          "00",
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
        ];
        let end = this.end.split(" ")[0];
        let date = this.start.split(" ")[0];
        let et0s = [];
        let z1 = this.anemometerHeight;
        let long = Number(this.longitude);
        const PI = Math.PI;
        const localLat = this.latitude * (PI / 180); //convertido para radianos

        info.typesPerSns.splice(0, 0, "ET0");
        info.ET0 = {
          measure: "ET0 diária",
          type: "column",
          unit: "mm",
          max: "1000000",
          min: "-1000000",
          data: [],
        };

        const airHumidityRegex = new RegExp("^UMIDADE RELATIVA\..*AR$")
        let airHumidityData =null
        // Umidade relativa do ar pode apresentar caracteres espaçados entre as letras
        Object.entries(info).forEach(([key,value])=>{
          if(airHumidityRegex.test(key))airHumidityData=value.data
        })

        for (
          date;
          date <= end;
          date = moment(date).add(1, "day").format("YYYY-MM-DD")
        ) {
          for (let h = 0; h < hours.length; h++) {
            try {
              let key = `${date} ${hours[h]}`;
              let windVelocity = info["VELOCIDADE DO VENTO"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let atmospherePreasure = info["PRESSÃO ATMOSFÉRICA"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let solarRadiation = info["RADIAÇÃO SOLAR"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let airTemperature = info["TEMPERATURA DO AR"].data.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let airHumidity = airHumidityData.filter(
                (e) => moment(e[0]).format("YYYY-MM-DD HH:MM").indexOf(key) > -1
              );
              let avgTemp = 0;
              let avgHumid = 0;
              let avgVel = 0;
              let rs = 0;
              let avgPreas = 0;
              if (airTemperature.length) {
                let temps = airTemperature.map((e) => Number(e[1]));
                let maxTemp = Math.max(...temps);
                let minTemp = Math.min(...temps);
                avgTemp = (maxTemp + minTemp) / 2;
              }
              if (airHumidity.length) {
                let humids = airHumidity.map((e) => Number(e[1]));
                let maxHumid = Math.max(...humids);
                let minHumid = Math.min(...humids);
                avgHumid = (maxHumid + minHumid) / 2;
              }
              if (windVelocity.length) {
                let vels = windVelocity.map((e) => Number(e[1]));
                avgVel = this.sumElems(vels) / vels.length;
                if (z1 !== null && z1 != 2)
                  avgVel = (avgVel * 4.87) / Math.log(67.8 * z1 - 5.42);
              }
              if (solarRadiation.length) {
                let rads = solarRadiation.map((e) => Number(e[1]));
                const seconds_between_reads = 3600 / solarRadiation.length;
                rs =
                  rads.reduce((acc, e) => e * seconds_between_reads + acc, 0) /
                  Math.pow(10, 6); //converte para MJ/m²h;
              }
              if (atmospherePreasure.length) {
                let preas = atmospherePreasure.map((e) => Number(e[1]));
                avgPreas = this.sumElems(preas) / preas.length / 10; //converte de hPa para kPa
              }

              const Gsc = 0.082; //MJ/m²/min
              const dayOfYear = moment(date).dayOfYear();
              const delta = 0.409 * Math.sin((2 * PI * dayOfYear) / 365 - 1.39);
              const Dr = 1 + 0.033 * Math.cos((2 * PI * dayOfYear) / 365);
              const auxSc = (2 * PI * (dayOfYear - 81)) / 364;
              const Sc =
                0.1645 * Math.sin(2 * auxSc) -
                0.1255 * Math.cos(auxSc) -
                0.025 * Math.sin(auxSc);

              const omegaAuxT = parseInt(h) + 0.5;
              let omegaAuxLm = long < 0 ? long * -1 : 360 - long;
              const omegaAuxLz = ((utc) => {
                let Lz = 0;
                let deg = utc * -1 * 15;
                Lz = utc < 0 ? deg : 360 - deg;
                return Lz;
              })(Number(this.utc));
              const omega =
                ((omegaAuxLz - omegaAuxLm) * 0.06667 + omegaAuxT + Sc - 12) *
                (PI / 12);
              let Ra;
              let Rso;
              let Rns;

              let kt = 0.95; // índice de turbidez do ar
              let denAuxFirstPart = Math.sin(localLat) * Math.sin(delta);
              let denAuxSecondPart =
                Math.cos(localLat) * Math.cos(delta) * Math.cos(omega);
              let den = denAuxFirstPart + denAuxSecondPart;
              let omegaS = Math.acos(-Math.tan(localLat) * Math.tan(delta));
              if (omega < -omegaS || omega > omegaS) {
                Ra = 0;
              } else {
                const omega1 = omega - PI / 24;
                const omega2 = omega + PI / 24;
                const RaAuxOmegasDiff = omega2 - omega1;
                const RaAuxFirstPart =
                  RaAuxOmegasDiff * Math.sin(localLat) * Math.sin(delta);
                const RaAuxSinDiff = Math.sin(omega2) - Math.sin(omega1);
                const RaAuxSecondPart =
                  RaAuxSinDiff * Math.cos(localLat) * Math.cos(delta);
                const RaAuxA = RaAuxFirstPart + RaAuxSecondPart;
                Ra = (12 * 60 * Gsc * Dr * RaAuxA) / PI;
              }
              Rso = Ra * Math.exp((-0.0018 * avgPreas) / (kt * den));
              Rns = (1 - 0.23) * rs;
              const eThrAux = (17.27 * avgTemp) / (avgTemp + 237.3);
              const eThr = 0.6108 * Math.exp(eThrAux);
              const Ea = (eThr * avgHumid) / 100;
              const DELTA =
                (4098 * eThr) / ((avgTemp + 237.3) * (avgTemp + 237.3));
              const gama = 0.665 * 0.001 * avgPreas;
              const sigma = 2.043 * Math.pow(10, -10); //em MJ/m²h
              const RnlAuxFirstPart = sigma * Math.pow(avgTemp + 273.16, 4);
              const RnlAuxSecondPart = 0.34 - 0.14 * Math.pow(Ea, 0.5);
              const RnlDivisionAuxThirdPart = Rso == 0 ? 0.8 : rs / Rso; //valor assumido quando Rso = 0 de acordo com exemplo
              const RnlAuxThirdPart = 1.35 * RnlDivisionAuxThirdPart - 0.35;
              const Rnl = RnlAuxFirstPart * RnlAuxSecondPart * RnlAuxThirdPart;
              const Rn = Rns - Rnl;
              const G = omega < -omegaS || omega > omegaS ? 0.5 * Rn : 0.1 * Rn;
              // const G = h > 5 && h < 18 ? 0.5 * Rn : 0.1 * Rn;

              /* Finalmente, o cálculo da ET0 */
              const ET0AuxFirstPartNumerator = 0.408 * (Rn - G);
              const ET0AuxFirstPart =
                (ET0AuxFirstPartNumerator * DELTA) /
                (DELTA + gama * (1 + 0.34 * avgVel));
              const ET0AuxSecondPartNumerator = 37 / (avgTemp + 273);
              const ET0AuxSecondPart =
                (ET0AuxSecondPartNumerator * avgVel * (eThr - Ea) * gama) /
                (gama * (1 + 0.34 * avgVel) + DELTA);
              const ET0 = ET0AuxFirstPart + ET0AuxSecondPart;

              et0s[h] = String(ET0) == "NaN" || ET0 < 0 ? 0.0 : ET0;
            } catch (e) {
              console.log(e);
            }
          }
          if (
            info.ET0.data.push([
              Math.round(new Date(date + "T00:00:00").getTime()),
              this.sumElems(et0s).toFixed(2),
            ]) == 8
          ) {
            resolve(info);
          }
        }
      });
    },
    sumElems(arr) {
      return arr.reduce((acc, value) => acc + value, 0);
    },
  },
};
</script>


<style scoped>
.chart-div {
  position: relative;
}
</style>
